import { observable, action, runInAction } from 'mobx'
import * as _ from 'lodash'
// import { message as Message } from 'antd'

import { StoreExt } from '@utils/reactExt'
// import { message } from 'antd'
import { Schema$ClubInfo, Schema$SimpleClubInfo, Schema$SimpleClubNotice } from '@interface/common'
import { IClubList, ISimpleClubList } from '@protocol/club'
import { BET_TYPE_ON } from 'adv-protocol/src/GameCommon'
import { isMobile } from 'react-device-detect'
import { authStore, componentStore, matchupStore } from '@store/index'

export type ClubInfoItem = Schema$ClubInfo
export type SimpleClubInfoItem = Schema$SimpleClubInfo

export class ClubStore extends StoreExt {
  @observable
  clubs: ClubInfoItem[]

  @observable
  simpleClubs: SimpleClubInfoItem[]

  singleBetPossibleClubs: ClubInfoItem[]

  singleBetType: BET_TYPE_ON

  selectedNotice: Schema$SimpleClubNotice

  clubInfoSorting = (items: ClubInfoItem[] | SimpleClubInfoItem[]): ClubInfoItem[] | SimpleClubInfoItem[] => {
    return items.sort((e1, e2) => {
      const e1Number = _.toNumber(e1.name.substring(0, 1))
      const e2Number = _.toNumber(e2.name.substring(0, 1))
      const isE1Number = _.isNumber(e1Number) && !_.isNaN(e1Number)
      const isE2Number = _.isNumber(e2Number) && !_.isNaN(e2Number)

      const isE1RecommendClub = e1.isRecommendClub
      const isE2RecommendClub = e2.isRecommendClub

      const e1Order = e1.recommendClubOrder
      const e2Order = e2.recommendClubOrder

      let returnValue
      if (isE1RecommendClub && !isE2RecommendClub) {
        returnValue = -1
      } else if (!isE1RecommendClub && isE2RecommendClub) {
        returnValue = 1
      }else if (e1Order > e2Order) {
        returnValue = 1
      } else if (e1Order < e2Order) {
        returnValue = -1
      } else if (isE1Number && !isE2Number) {
        returnValue = 1
      } else if (!isE1Number && isE2Number) {
        returnValue = -1
      } else {
        returnValue = e1.name.localeCompare(e2.name, ['ko-KR', 'en-US'])
      }
      return returnValue
    })
  }

  @action
  fetchSimpleClubs = async (params?: ISimpleClubList.Params) => {
    try {
      const { items } = await this.api.club.getSimpleClubList(params)
      const sortedClubInfos = this.clubInfoSorting(items)
      this.setSimpleClubs(sortedClubInfos)
    } catch (err) {
      console.error(err)
    }
  }

  @action
  fetch = async (params: IClubList.Params) => {
    try {
      const { items } = await this.api.club.getClubList(params)
      const sortedClubInfos = this.clubInfoSorting(items)
      this.setClubs(sortedClubInfos as ClubInfoItem[])
    } catch (err) {
      console.error(err)
    }
  }

  @action
  setSimpleClubs = (clubs: SimpleClubInfoItem[]): SimpleClubInfoItem[] => {
    this.simpleClubs = clubs
    return clubs
  }

  @action
  updateSimpleClubsAfterJoin = (club: Schema$ClubInfo): void => {
    const updatedClubs = _.map(this.simpleClubs, simpleClub =>
      simpleClub.id === club.id
        ? {
          ...simpleClub,
          isMember: club.isMember,
        }
        : simpleClub,
    )
    this.setSimpleClubs(updatedClubs)
  }

  @action
  setClubs = (clubs: ClubInfoItem[]): ClubInfoItem[] => {
    this.clubs = clubs
    return clubs
  }

  @action
  fetchUnReadClubMessageCount = async (clubId: string) => {
    try {
      const { count } = await this.api.club.getUnReadClubMessageCount({ clubId })
      runInAction(() => {
        const { club } = matchupStore
        const { extraClubId } = componentStore

        if (_.eq(clubId, club.id)) {
          matchupStore.setUnreadClubMessageCount(count)
        }

        if (_.eq(clubId, extraClubId)) {
          componentStore.setExtraClubUnreadMessageCount(count)
        }
      })
    } catch (err) {
      console.error(err)
    }
  }

  getSingleBetPossibleClubList = async (betType: BET_TYPE_ON) => {
    try {
      this.singleBetType = betType
      const { items } = await this.api.club.getSingleBetPossibleList({ betType })
      this.singleBetPossibleClubs = items
    } catch (err) {
      console.error(err)
    }
  }

  setSelectedNotice = (notice: Schema$SimpleClubNotice): void => {
    this.selectedNotice = notice
  }

  getSelectedNotice = () => this.selectedNotice

  documentVisibleChangeHandler(isHidden: boolean): void {
    if (!isMobile) {
      return
    }

    if (!authStore.isSignedIn) {
      return
    }

    if (isHidden) {
      return
    }

    const { club } = matchupStore
    if (_.isEmpty(_.trim(club?.id))) {
      return
    }
    this.fetchUnReadClubMessageCount(club.id)
  }

  async getClubNoticeList(clubId: string): Promise<Schema$SimpleClubNotice[]> {
    try {
      const { items } = await this.api.club.getClubNoticeList({ clubId })
      return items
    } catch (err) {
      console.error(err)
    }
    return []
  }
}

export default new ClubStore()
